import React, { useState, useRef } from 'react';
import AdUnit from '../components/AdUnit';
import SEO from '../components/SEO';

const WheelSpinPage = () => {
  const [names, setNames] = useState(['Tuğkan', 'Kaan', 'Ahmet', 'Mesut', 'Can', 'Mustafa', 'Oğuz', 'Mahir']);
  const [inputName, setInputName] = useState('');
  const [isSpinning, setIsSpinning] = useState(false);
  const [winner, setWinner] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [group1, setGroup1] = useState([]);
  const [group2, setGroup2] = useState([]);
  const [currentGroup, setCurrentGroup] = useState(1);
  const wheelRef = useRef(null);

  const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];

  const addName = () => {
    if (inputName.trim() && !names.includes(inputName.trim())) {
      setNames([...names, inputName.trim()]);
      setInputName('');
    }
  };

  const removeName = (index) => {
    setNames(names.filter((_, i) => i !== index));
    setWinner(null);
  };

  const clearAll = () => {
    if (isSpinning) return;
    setNames([]);
    setInputName('');
    setWinner(null);
    setRotation(0);
    setGroup1([]);
    setGroup2([]);
    setCurrentGroup(1);
  };

  const spinWheel = () => {
    if (names.length === 0 || isSpinning) return;

    setIsSpinning(true);
    setWinner(null);

    // Random kazanan seç (0'dan names.length-1'e kadar)
    const winnerIndex = Math.floor(Math.random() * names.length);

    // Her segment için açı hesapla
    const segmentAngle = 360 / names.length;

    // Wheel'in şu anki pozisyonunu hesapla (0-360 arası normalize et)
    const currentAngle = rotation % 360;

    // Kazanan segment'in ortası pointer'a gelecek şekilde hedef açıyı hesapla
    const targetAngle = -(winnerIndex * segmentAngle + segmentAngle / 2);

    // Kaç tam tur atılmış hesapla
    const completedSpins = Math.floor(rotation / 360);

    // Yeni rotation: önceki turlar + minimum 5 yeni tur + hedef pozisyon
    const minSpins = 5;
    const newRotation = (completedSpins + minSpins) * 360 + targetAngle;

    setRotation(newRotation);

    // Animasyon bitince kazananı göster ve listeden çıkar
    setTimeout(() => {
      setIsSpinning(false);
      const winnerName = names[winnerIndex];
      setWinner(winnerName);

      // Kazananı ilgili gruba ekle
      if (currentGroup === 1) {
        setGroup1(prev => [...prev, winnerName]);
        setCurrentGroup(2);
      } else {
        setGroup2(prev => [...prev, winnerName]);
        setCurrentGroup(1);
      }

      // Kazananı listeden kaldır
      setNames(prevNames => prevNames.filter((_, index) => index !== winnerIndex));
    }, 4000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      addName();
    }
  };

  return (
    <div className="container">
      <SEO
        title="Wheel Spin - Random Name Picker | YourJSONTools"
        description="Spin the wheel to randomly pick a name. Add names and let the wheel decide the winner."
        keywords="wheel spin, random picker, name picker, raffle, giveaway, random name"
      />

      <h1>Wheel Spin</h1>
      <p className="tool-description">
        Add names and spin the wheel to randomly pick a winner. Perfect for raffles, giveaways, and decision making.
      </p>

      <div className="wheel-container">
        {/* Sol taraf - İsim listesi ve kontroller */}
        <div className="controls-section">
          <div className="input-group">
            <input
              type="text"
              value={inputName}
              onChange={(e) => setInputName(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter a name"
              className="name-input"
              disabled={isSpinning}
            />
            <button onClick={addName} className="add-button" disabled={isSpinning}>
              Add
            </button>
          </div>

          <div className="names-list">
            <div className="list-header">
              <h3>Names ({names.length})</h3>
              <button onClick={clearAll} className="clear-all-button" disabled={isSpinning}>
                Clear All
              </button>
            </div>
            <div className="names-items">
              {names.map((name, index) => (
                <div key={index} className="name-item" style={{ borderLeft: `4px solid ${colors[index % colors.length]}` }}>
                  <span>{name}</span>
                  <button
                    onClick={() => removeName(index)}
                    className="remove-button"
                    disabled={isSpinning}
                  >
                    ×
                  </button>
                </div>
              ))}
              {names.length === 0 && (
                <div className="empty-message">No names added yet</div>
              )}
            </div>
          </div>

          <button
            onClick={spinWheel}
            disabled={names.length === 0 || isSpinning}
            className="spin-button"
          >
            {isSpinning ? 'Spinning...' : 'Spin the Wheel!'}
          </button>

          {/* Gruplar */}
          {(group1.length > 0 || group2.length > 0) && (
            <div className="groups-container">
              <div className="group-box">
                <h3 className="group-title">Group 1</h3>
                <div className="group-members">
                  {group1.length > 0 ? group1.map((name, index) => (
                    <div key={index} className="group-member">{name}</div>
                  )) : (
                    <div className="group-empty">No members yet</div>
                  )}
                </div>
              </div>

              <div className="group-box">
                <h3 className="group-title">Group 2</h3>
                <div className="group-members">
                  {group2.length > 0 ? group2.map((name, index) => (
                    <div key={index} className="group-member">{name}</div>
                  )) : (
                    <div className="group-empty">No members yet</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Sağ taraf - Wheel */}
        <div className="wheel-section">
          <div className="wheel-section-inner">
            <div className="wheel-wrapper">
              {/* Pointer - üstte sabit */}
              <div className="wheel-pointer">▼</div>

            {/* Wheel */}
            <svg
              ref={wheelRef}
              className="wheel"
              viewBox="0 0 200 200"
              style={{
                transform: `rotate(${rotation}deg)`,
                transition: isSpinning ? 'transform 4s cubic-bezier(0.17, 0.67, 0.12, 0.99)' : 'transform 0.3s ease-out'
              }}
            >
              {names.length > 0 ? names.map((name, index) => {
                const segmentAngle = 360 / names.length;
                const startAngle = index * segmentAngle - 90; // -90 to start from top
                const endAngle = startAngle + segmentAngle;

                // Text position (middle of segment)
                const midAngle = startAngle + segmentAngle / 2;
                const midRad = (midAngle * Math.PI) / 180;
                const textX = 100 + 65 * Math.cos(midRad);
                const textY = 100 + 65 * Math.sin(midRad);

                // Eğer tek isim varsa (360 derece), tam daire çiz
                if (names.length === 1) {
                  return (
                    <g key={index}>
                      <circle
                        cx="100"
                        cy="100"
                        r="95"
                        fill={colors[index % colors.length]}
                        stroke="white"
                        strokeWidth="2"
                      />
                      <text
                        x={textX}
                        y={textY}
                        fill="white"
                        fontSize="10"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
                      >
                        {name.length > 12 ? name.substring(0, 10) + '...' : name}
                      </text>
                    </g>
                  );
                }

                // Convert to radians
                const startRad = (startAngle * Math.PI) / 180;
                const endRad = (endAngle * Math.PI) / 180;

                // Calculate path
                const x1 = 100 + 95 * Math.cos(startRad);
                const y1 = 100 + 95 * Math.sin(startRad);
                const x2 = 100 + 95 * Math.cos(endRad);
                const y2 = 100 + 95 * Math.sin(endRad);

                const largeArc = segmentAngle > 180 ? 1 : 0;

                const pathData = `M 100 100 L ${x1} ${y1} A 95 95 0 ${largeArc} 1 ${x2} ${y2} Z`;

                return (
                  <g key={index}>
                    <path
                      d={pathData}
                      fill={colors[index % colors.length]}
                      stroke="white"
                      strokeWidth="2"
                    />
                    <text
                      x={textX}
                      y={textY}
                      fill="white"
                      fontSize="10"
                      fontWeight="bold"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
                    >
                      {name.length > 12 ? name.substring(0, 10) + '...' : name}
                    </text>
                  </g>
                );
              }) : (
                <g>
                  <circle cx="100" cy="100" r="95" fill="#e0e0e0" stroke="white" strokeWidth="2" />
                  <text x="100" y="100" fill="#666" fontSize="12" textAnchor="middle" dominantBaseline="middle">
                    Add names to start
                  </text>
                </g>
              )}
              {/* Center circle */}
              <circle cx="100" cy="100" r="10" fill="white" stroke="#333" strokeWidth="2" />
            </svg>
            </div>

            {/* Winner announcement - çarkın altında */}
            {winner && (
              <div className="winner-announcement">
                <div className="winner-label">Winner:</div>
                <div className="winner-name">{winner}</div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .wheel-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .controls-section {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .input-group {
          display: flex;
          gap: 0.5rem;
        }

        .name-input {
          flex: 1;
          padding: 0.75rem;
          font-size: 1rem;
          border: 2px solid #dee2e6;
          border-radius: 6px;
          outline: none;
        }

        .name-input:focus {
          border-color: #4ECDC4;
        }

        .name-input:disabled {
          background: #f8f9fa;
          cursor: not-allowed;
        }

        .add-button {
          padding: 0.75rem 1.5rem;
          font-size: 1rem;
          font-weight: 600;
          background: #4ECDC4;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .add-button:hover:not(:disabled) {
          background: #3db8af;
          transform: translateY(-1px);
        }

        .add-button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

        .names-list {
          background: white;
          border: 2px solid #dee2e6;
          border-radius: 8px;
          overflow: hidden;
        }

        .list-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: #f8f9fa;
          border-bottom: 2px solid #dee2e6;
        }

        .list-header h3 {
          margin: 0;
          font-size: 1.1rem;
          color: #333;
        }

        .clear-all-button {
          padding: 0.4rem 0.8rem;
          font-size: 0.875rem;
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .clear-all-button:hover:not(:disabled) {
          background: #c82333;
        }

        .clear-all-button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

        .names-items {
          max-height: 300px;
          overflow-y: auto;
        }

        .name-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 1rem;
          border-bottom: 1px solid #f0f0f0;
          transition: background 0.2s;
        }

        .name-item:hover {
          background: #f8f9fa;
        }

        .name-item:last-child {
          border-bottom: none;
        }

        .name-item span {
          font-size: 1rem;
          color: #333;
        }

        .remove-button {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          font-size: 1.2rem;
          line-height: 1;
          transition: all 0.2s;
        }

        .remove-button:hover:not(:disabled) {
          background: #c82333;
          transform: scale(1.1);
        }

        .remove-button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

        .empty-message {
          padding: 2rem;
          text-align: center;
          color: #999;
          font-style: italic;
        }

        .spin-button {
          padding: 1rem 2rem;
          font-size: 1.2rem;
          font-weight: 700;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }

        .spin-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
        }

        .spin-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .spin-button:disabled {
          background: #ccc;
          cursor: not-allowed;
          box-shadow: none;
        }

        .winner-announcement {
          padding: 1.5rem;
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          border-radius: 8px;
          text-align: center;
          animation: slideIn 0.5s ease-out;
          width: 100%;
          max-width: 500px;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .winner-label {
          font-size: 1rem;
          color: white;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        .winner-name {
          font-size: 2rem;
          font-weight: 700;
          color: white;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
        }

        .groups-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-top: 1rem;
        }

        .group-box {
          background: white;
          border: 2px solid #dee2e6;
          border-radius: 8px;
          overflow: hidden;
        }

        .group-title {
          margin: 0;
          padding: 1rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-size: 1.1rem;
          font-weight: 600;
          text-align: center;
        }

        .group-members {
          padding: 1rem;
          min-height: 100px;
        }

        .group-member {
          padding: 0.75rem;
          margin-bottom: 0.5rem;
          background: #f8f9fa;
          border-left: 4px solid #667eea;
          border-radius: 4px;
          font-weight: 500;
          color: #333;
        }

        .group-member:last-child {
          margin-bottom: 0;
        }

        .group-empty {
          padding: 2rem;
          text-align: center;
          color: #999;
          font-style: italic;
        }

        .wheel-section {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .wheel-section-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2rem;
          width: 100%;
        }

        .wheel-wrapper {
          position: relative;
          width: 100%;
          max-width: 500px;
          aspect-ratio: 1;
        }

        .wheel-pointer {
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 2rem;
          color: #dc3545;
          z-index: 10;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
        }

        .wheel {
          width: 100%;
          height: 100%;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
        }

        @media (max-width: 1024px) {
          .wheel-container {
            grid-template-columns: 1fr;
          }

          .wheel-wrapper {
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .wheel-wrapper {
            max-width: 350px;
          }

          .winner-name {
            font-size: 1.5rem;
          }

          .spin-button {
            font-size: 1rem;
            padding: 0.875rem 1.5rem;
          }

          .groups-container {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .wheel-wrapper {
            max-width: 300px;
          }

          .input-group {
            flex-direction: column;
          }

          .add-button {
            width: 100%;
          }
        }
      `}</style>

      <AdUnit />
    </div>
  );
};

export default WheelSpinPage;
